import React from 'react';

import { SPACES } from '@lumapps/communities/keys';
import { Tooltip } from '@lumapps/lumx/react';
import { useTranslate } from '@lumapps/translations';

import { useSpaceDataFromRedux } from '../../hooks/useSpaceDataFromRedux';
import { SpaceHeader } from './index';
import { SpaceHeaderSkeleton } from './SpaceHeaderSkeleton';

interface HeaderDesignerPreviewProps {
    spaceId: string;
}

const CLASSNAME = 'space-header-designer-preview';
export const SpaceHeaderDesignerPreview: React.FC<HeaderDesignerPreviewProps> = ({ spaceId }) => {
    const { translateKey } = useTranslate();

    const { hasInit, isLoading, spaceData, hasError } = useSpaceDataFromRedux(spaceId);

    if (!hasInit || isLoading) {
        return <SpaceHeaderSkeleton />;
    }

    if (hasError || !spaceData) {
        return null;
    }

    return (
        <Tooltip label={translateKey(SPACES.HEADER_NOT_EDITABLE)}>
            <div className={CLASSNAME}>
                <SpaceHeader isPreview spaceId={spaceId} {...spaceData} />
            </div>
        </Tooltip>
    );
};
